// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1NSpx","alert":"SettungsInbox_alert__19eJQ"};